<template>
  <v-bottom-sheet :value="!!user" @input="closeUserProfile()" dark inset>
    <v-overlay :value="isLoading" absolute color="#1e1e1e" opacity="0.8">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>

    <v-sheet rounded="t-xl" style="background-color: #1e1e1e">
      <v-container class="pa-4 text-center">
        <v-avatar size="100" class="mb-3" color="grey darken-2">
          <v-img v-if="user && user.bild" :src="'/img/profilbilder/' + user.bild"></v-img>
          <span v-else class="white--text headline">{{ getInitials(user) }}</span>
        </v-avatar>
        <h2 class="headline mb-1">{{ user ? user.vorname : "" }} {{ user ? user.nachname : "" }}</h2>

        <v-chip small :color="presence.isOnline ? 'primary' : 'grey darken-2'">
          <v-icon left small>{{ presence.isOnline ? "mdi-wifi" : "mdi-wifi-off" }}</v-icon>
          {{ presence.isOnline ? "Online" : lastSeenText }}
        </v-chip>
      </v-container>

      <v-divider></v-divider>

      <div class="pa-4">
        <h4 class="text-uppercase grey--text text--lighten-1 mb-2">Gemeinsame Gruppen</h4>
        <v-list dark color="transparent" v-if="commonGroups.length > 0">
          <v-list-item v-for="group in commonGroups" :key="group._id" class="mb-1" color="grey darken-3" rounded="lg">
            <v-list-item-avatar color="grey darken-2">
              <v-img v-if="group.bild" :src="'/img/profilbilder/' + group.bild"></v-img>
              <v-icon v-else dark>mdi-account-group</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ group.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div v-else class="text-center grey--text pa-4">Keine gemeinsamen Gruppen (ausser dieser).</div>
      </div>

      <v-btn text color="grey" @click="closeUserProfile" class="my-2" block> Schliessen </v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex"
// TODO: Importiere 'formatDistanceToNowStrict' von 'date-fns' für geile Zeit-Formatierung
// import { formatDistanceToNowStrict } from 'date-fns';
// import { de } from 'date-fns/locale';

export default {
  name: "UserProfileDialog",
  computed: {
    // Holt den User, den wir anzeigen
    ...mapState("chatStore", {
      user: "viewedUserProfile",
      commonGroups: "commonGroups",
      isLoading: "isLoadingProfile",
    }),

    // Holt den Live-Status des Users
    ...mapGetters("chatStore", ["getPresenceByUserId"]),

    presence() {
      if (!this.user) return { isOnline: false }
      return this.getPresenceByUserId(this.user._id) || { isOnline: false }
    },

    lastSeenText() {
      if (!this.presence || !this.presence.lastSeen) return "Offline"
      try {
        // TODO: "date-fns" für "vor 5 Minuten" installieren
        // return `Zuletzt online: ${formatDistanceToNowStrict(new Date(this.presence.lastSeen), { addSuffix: true, locale: de })}`;

        // Simpler Fallback:
        const date = new Date(this.presence.lastSeen)
        return `Zuletzt online: ${date.toLocaleDateString("de-CH")} ${date.toLocaleTimeString("de-CH")}`
      } catch (e) {
        return "Offline"
      }
    },
  },
  methods: {
    ...mapActions("chatStore", ["closeUserProfile"]),
    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },
  },
}
</script>
